import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myRenewRoute: RouteConfig<'with-page'> = {
    name: 'Renew',
    path: '/myaccount/renew',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['no-menu-item','member-route', 'member-renew'],
}